<template>
  <v-dialog
    v-model="newJobDialog"
    persistent
    retain-focus
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        Create a new job
      </v-card-title>
      <v-card-text>
        <v-form v-model="formValid">
          <ol-text-field
            v-model="newJobId"
            label="Job Id*"
            required
            :rules="[(v) => !!v || 'This field is required.']"
            @input="newJobIdDirty = true"
          />
          <ol-text-field
            v-model="newJobName"
            label="Job Name*"
            required
            :rules="[(v) => !!v || 'This field is required.']"
            @input="newJobNameDirty = true"
          />
          <ol-text-field
            label="Client(s)"
            disabled
            read-only
            :value="selectedJobObjects[0] && selectedJobObjects[0].clientDetails.map(clientUser => clientUser.name).sort().join(', ') "
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color=""
          :disabled="newJobSaving"
          text
          @click="$emit('close')"
        >
          Close
        </v-btn>
        <v-btn
          :disabled="!newJobValid || newJobSaving"
          color="primary"
          :loading="newJobSaving"
          @click="saveNewJob"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { auth } from '@/firebase'

export default {
  name: 'NewJobDialog',
  props: {
    newJobDialog: { type: Boolean, default: false },
    pNewJobId: { type: String, default: '' },
    pNewJobName: { type: String, default: '' },
    selectedJobObjects: { type: Array, default: () => [] },
    selectedClientObjects: { type: Array, default: () => [] }
  },
  data: () => ({
    formValid: false,
    newJobId: '',
    newJobIdDirty: false,
    newJobName: '',
    newJobNameDirty: false,
    newJobSaving: false
  }),
  computed: {
    newJobIdValid() {
      return this.newJobId.length > 0
    },
    newJobNameValid() {
      return this.newJobName.length > 0
    },
    newJobValid() {
      return this.newJobIdValid && this.newJobNameValid
    }
  },
  watch: {
    newJobDialog: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.newJobId = this.pNewJobId
          this.newJobName = this.pNewJobName
        }
      },
      immediate: true
    }
  },
  methods: {
    saveNewJob: async function () {
      this.newJobSaving = true

      /* TODO current, new jobs are only unique to an account. Thus, a third party, e.g. a lawyer,
         could potentially see the same jobId but that are actually different jobs. How to handle? */

      try {
        await this.$firePost('jobs/createJob', auth, {
          accountId: this.$store.state.account.id,
          jobId: this.newJobId,
          jobName: this.newJobName,
          clients: this.selectedClientObjects.map(clientUser => clientUser.id)
        })
        this.$emit('close', true)
      } catch (e) {
        this.$showErrorbar('Error saving job: ' + (this.$gnp(e, 'response.data.message') || 'Refresh and try again.'))
        this.$Sentry.captureException(e)
      }
      this.newJobSaving = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
